import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addloantype',
  templateUrl: './addloantype.component.html',
  styleUrls: ['./addloantype.component.css']
})
export class AddloantypeComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname:String="LoanType";

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;


//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;
//Edit Get Values
loantypeColl:any=[];
loantypeBO:any={};

loantypeid:number=0

loantypeform=new FormGroup({
  loantypeid:new FormControl(0),          
  loantype:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.loantypeid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }


  });
}


ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
  try {
    this.isaddmode = true;
    this.loantypeform.reset();
    this.fnInitializeFormGroup();

    if (this.loantypeid > 0) {
      this.fngetLoanType();
    }
  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.loantypeid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}

ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}


fnInitializeFormGroup(){
   this.loantypeform.setValue({
    loantypeid:0,    
    loantype:'',
     inactive:false              
   })
}

//Get 
fngetLoanType() {        
     var data = {
       'loantypeid':this.loantypeid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getLoanType(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){  
           this.loantypeColl=res.json().result;
           var editdata = this.loantypeColl[0];        
           this.fnEditMode(editdata);
           this.loantypeBO=editdata;
         }
         else {
           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{          
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{ if (this.saveloading) {
    return;
  }


     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.loantypeform.valid){ this.saveloading = true;
         //Check
         var data = {
               'loantypeid': this.loantypeid,                      
               'loantype':this.loantypeform.get('loantype').value, 
               'inactive':this.loantypeform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckLoanType(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.loantypeform.get('loantypeid').value>0){
                       //Update 
                       this.fnSetLoanType(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertLoanType(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;
                       this.loantypeform.controls['loantype'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertLoanType(data){    
 
   this.appService.fnInsertLoanType(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new loantype has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.loantypename);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetLoanType(data){    

this.appService.fnSetLoanType(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The loantype has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.loantypeid,data.loantypename);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/LoanType']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.loantypeform.setValue({ 
  loantypeid:deptBO.loantypeid,     
  loantype:deptBO.loantype,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}

private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}








}
